import styled from '@emotion/styled'
import { Box, Typography, FormControlLabel } from '@mui/material'
import { exportToPPT_tableCss } from '../../../../util'
import { MEDIA } from '../../../../constants'

export const RootWrap = styled(Box)(`
	@media (max-width: ${MEDIA.lg}) {
		padding:20px 20px 40px 20px;
	}
`)

export const MuiButtonWrap = styled(Box)(`
    position:relative;
`)

export const GridHeaderWrapper = styled(Box)(`
    display:flex;
    width:100%;
    position:relative;
`)

export const ContentWrap = styled(Box)(`
	width: 100%;
	& .segmentRowWrap {
		flex-direction: column;
	}
`)

export const HeaderWrap = styled(Box)(`
	display: flex;
	align-items: center;
	width: 100%;
`)

export const HeaderTab = styled(Box)(`
    display: flex;
	align-items: center;
	background: #F7F7F9;
	padding: 6px 10px;
	// overflow: hidden; // showing error when we click on Global Tutorial Button
	width: 100%;
	& .tab {
		padding: 5px 10px;
		font-size: 12px;
		font-weight: 400; // 300;
		margin-right: 2px;
		cursor: pointer;
		position:relative;

		&.active {
			background: #fff;
			font-weight: 600; // 500;
		}
	}
`)

export const SegmentWrap = styled(Box)(`
	width: 100%;
	& > .segmentRows:last-child {
		margin-bottom:-1px;
	}
`)

export const SegmentRowDetails = styled(Box)(`
	padding:5px 0;
	width:100% !important;
`)

export const NoDataFound = styled(Box)(`
	padding:5px 0;
	width:100%;
	font-weight: 400;
	font-size: 13px;
	line-height: 32px;
	color: #000000;
`)

export const SegmentRowHeading = styled(Box)(`
	padding: 1px 0 1px 0;
	width: 100%;
	font-weight: 600;
	font-size: 14px;
	line-height: 32px;
	color: #000000;
	display:flex;
	justify-content:space-between;
	border-bottom:1px #fff solid;
	align-items: center;
	&.selected{
		color: #095BBD;
		& svg {
			transform: rotate(180deg);
			path {
				fill: #095BBD;
			}
		}
	}
	& svg {
		// transition: ease-in-out .5s;
	}
`)

export const SegmentRow = styled(Box)(`
	font-size: 12px;
	font-weight: 400;
	margin-bottom: 12px;
	position: relative;
	display:flex;
	flex-direction: column;
	justify-content: center;

	& .outerText{
		min-width: 32px;
		font-size: 12px;
		margin-left: 6px;
		font-weight: 400; // 300;
	}

	& .expandButton {
		position: absolute;
		top:3px;
		right:0;
		width: auto;
	}
`)

export const SegmentRowContent = styled(Box)(`
	display: flex;
	align-items: center;
	position: relative;
	padding:0;
	border-bottom: 1px #E7E7E6 solid
`)

export const SegmentTitle = styled(Typography)(`
	font-size: 14px;
	font-weight: 400;
	width: 220px;
	text-align: left;
	line-height: 18px;
	border-right: 1px #D8D8D6 solid;
    margin: 0;
    min-height: 14px;
    padding: 6px;
	background: #fff;
	z-index:4;
`)

export const SegmentSubTitle = styled(Typography)(`
	width: auto;
	min-width: 100px;
	font-weight: 600;
	font-size: 14px;
	line-height: 16px;
	margin: 8px 0 5px 8px;
`)

export const TableHeading = styled(Box)(`
	display: flex;
	width: 100%;
	& span {
		font-size: 14px;
		font-weight: 400;
		line-height: 32px;
		color: #000;
		display: block;
		padding: 0 8px;
	}
	& span:nth-child(1) { width: 200px;	}
	& span:nth-child(2) { width: calc(50% - 135px);	}
	& span:nth-child(3) { width: calc(50% - 135px);	}
	
`)

export const BarWrap = styled(Box)(`
	width: 100%;
	&.association {
		background: #F1F1F3;
		border-radius: 0px 20px 20px 0px;
		padding: 4px;
		& .barSlice {
			border-radius: 0px 20px 20px 0px;
			// height: 8px !important;
		}
	}
	& .barRoot, .barItemRoot, .barSliceWrap, .barSlice {
		// height: 5px !important;
	}
	& .barSlicePercentage, & .barSliceLabel{
		font-size: 12px !important;
	}
	& .roundedBars{
		.barSlice {
			border-radius: 0 8px 8px 0;
			border: 1px #fff solid;
			border-width: 1px 1px 1px 0;
			padding-left:5px;
			margin-left:-5px;
			position: relative;
		}
		// & .barSlice:first-child { padding-left:0; margin-left:0; }
		& .barSlice.Positive { z-index: 3; }
		& .barSlice.Neutral { z-index: 2; }
		& .barSlice.Mixed { z-index: 1; }
		& .barSlice.Negative { z-index: 0; }
		& li .barSlice.showToolTip::before { z-index: 4; }

		& .barSlice[data-tool="0%"] { display:none; }
	}
`)

export const IssuesWrap = styled(Box)(`
	position: absolute;
	left: calc(100% + 5px);
	display: flex;
	align-items: center;

	& .radio {
		width: 10px;
		height: 10px;
		min-width: 10px;
		min-height: 10px;
		border: 1px solid #7E7E7E;
		margin-right: 4px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		& .box {
			width: 4.5px;
			height: 4.5px;
			min-width: 4.5px;
			min-height: 4.5px;
			background: #7E7E7E;
			border-radius: 50%;
		}
	}
	& .radio-text {
		font-size: 12px;
		font-weight: 400; // 300;
		white-space: nowrap;
	}
	
	@media (max-width: ${MEDIA.lg}) {
		overflow: hidden;
		width: 250px;
		flex-wrap: wrap;
		height: 20px;
	}
`)

export const ComparisonViewWrap = styled(Box)(`
	width: 100%;
	display: flex;
	justify-content: center;

	& .segment-row:last-child {
		margin-bottom:-1px !important;
	}
	& .segment-row-content {
		margin-left: -140px;
		padding-right: 40px;
		& .segment-title {
			margin-right: 20px;
		}
		& .barRoot, .barItemRoot, .barSliceWrap, .barSlice {
			height: 20px !important;
		}
	}
`)

export const SegmentDetailsLevel2 = styled(Box)(`
	background:#F6F6F5;
	width:100%;
	display:flex;
	flex-direction:column;
	padding:12px 0;
	border-radius:4px;
	margin-top:8px;
`)

export const SegmentDetailsLevel2Title = styled(Box)(`
	width: 100%;
	font-size: 17px;
	font-weight: 400;
	line-height: 28px;
	padding:4px 8px;
	display:flex;
	justify-content:space-between;
`)

export const SegmentDetailsLevel2ListingLHS = styled(Box)(`
	width:100%;
	& > div:last-child{
		border-bottom:0;
	}
`)

export const SegmentAccordionLevel2Wrap = styled(Box)(`
	padding:8px;

	& .segmentTitle {
		background: #F6F6F5;
	}
`)

export const SegmentAccordionLevel2Heading = styled(Box)(`
	width:100%;
	display:flex;
	justify-content:space-between;
	align-items:center;
	padding-bottom:8px;
	font-weight: 600;
	font-size: 14px;
	line-height: 14px;
	cursor:pointer;

	&.selected{
		font-weight: 600;
		color: #095BBD;
		& svg path {
			fill: #095BBD;
		}
	}
`)

export const SegmentAccordionLevel2Details = styled(Box)(`
	width:100%;
	display:flex;
	flex-direction:column;

	& table { background: #fff; }
`)

export const SegmentDetailsLevel2ListingRHS = styled(Box)(`
	margin: 8px 0;
	padding: 8px 0;
	border: 1px #ADADAC solid;
	width:100%;
	border-radius:4px;

	& > div > div > div > div {
		margin-bottom:0;
	}

	& button { padding:0; }
`)

export const SegmentAccordionLevel3Heading = styled(Box)(`
	width:100%;
	padding:0 8px 8px 8px;
	font-size: 17px;
	font-style: normal;
	font-weight: 400;
	line-height: 28px;
	display: flex;
    justify-content: space-between;
    align-items: center;
`)

export const SegmentAccordionLevel3Wrap = styled(Box)(`
	padding:5px 0;
`)

export const SegmentAccordionLevel3SubHeading = styled(Box)(`
	font-weight: 400;
	font-size: 14px;
	// line-height: 14px;
	padding-left:8px;
`)

export const SegmentAccordionLevel3Details = SegmentAccordionLevel2Details

export const ProgressionWrapper = styled(Box)(`
	padding-bottom:10px;
	display: flex;
	padding: 8px;
	background: #F6F6F5;
	border-radius: 4px;
	margin-bottom: 10px;

	& .SelectThemeV2Wrapper {
		margin-right: 10px;
	}
`)

// Filter Section CSS
export const FilterOuterWrap = styled(Box)(`
	display: flex;
	width: 100%;
	margin-top:-40px;

	.filterButton {
		color: #095BBD;
		font-size: 14px;
		font-weight: 600; // 500;
		background: none;
		padding: 0;
		min-width: auto;
		margin-bottom:10px;
	}
`)

export const FilterExpanded = styled(Box)(`
	display: flex;
	width: 100%;
	flex-direction: column;
    align-items: flex-start;
	padding-bottom: 15px;
	& label span {
		line-height: 15px !important;
		font-size: 14px !important;
	}
	& .selectAll {
		margin-left:-16px;
		color:#095BBD;
	}
	& svg {
		margin-left:10px;
	}
`)

export const FilterCollapsed = styled(Box)(`
	display: flex;
	width: 100%;

	& svg {
		margin-left:10px;
		transform: rotate(180deg);
	}
`)

export const FilterHeading = styled(Typography)(`
	display: flex;
	width: 100%;
	color: #000;
	font-size: 14px;
	font-weight: 600; // 500;
`)

export const FilterSelectAll = styled(FormControlLabel)(`
  & .MuiTypography-root {
    font-size: 14px;
    font-weight: 400;
	color: #095BBD;
  }
  & .MuiCheckbox-root{
    padding: 0;
    margin: 3px 10px auto 12px;
  }
`)

export const FilterCheckboxWrap = styled(Box)(`
	display: flex;
	padding: 5px;
	flex-wrap: wrap;
	width: 100%;
	& label {
		width: 180px;
		align-items: flex-start;
		padding-bottom: 10px !important;
	}
	& label span {
		// line-height: 15px !important;
		// font-size: 14px !important;
		padding-top:0 !important;
		white-space: break-spaces !important;
	}

`)

export const FilterButtonsWrap = styled(Box)(`
	display: flex;
	width: 100%;
	justify-content: end;
	padding: 15px 0 30px 0;
`)

export const SegmentProductsWrapper = styled(Box)(`
	border: 1px #E7E7E6 solid;
	border-radius: 4px;
	& > div:last-child{border: 0;}
`)
